import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersEmployeeSurveySubmissionsIndexRequestType,
  ApiMembersEmployeeSurveySubmissionsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersEmployeeSurveySubmissionsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersEmployeeSurveySubmissionsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeeSurveySubmissionsIndexResponseType>(
      "/api/members/employee_survey_submissions",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersEmployeeSurveySubmissionsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeeSurveySubmissionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersEmployeeSurveySubmissionsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersEmployeeSurveySubmissionsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
